import PayMaya from "./paymaya";
import ECPay from "./ecpay";
import TSYS from "./tsys";
import PowerTranz from "./powertranz";
import Xendit from "./xendit";
import Generic from "./generic";
import Avis from "./avis";

const ComponentMapper = {
  paymaya: PayMaya,
  ecpay: ECPay,
  tsys: TSYS,
  powertranz: PowerTranz,
  xendit: Xendit,
  avis: Avis,
  allinpay: Avis,
};

export const getComponentForEnumValue = (enumValue) => {
  return ComponentMapper[enumValue.toLowerCase()] || Generic;
};
